import { NgModule } from '@angular/core';
import { RoutingRuleComponent } from './component/routing-rule.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MaterialModule } from '@sdbn/appclient';
import { SharedModule } from 'src/app/shared/shared.module';

import { ApplicationClientCommonModule } from '@sdbn/appclient';


@NgModule({
    declarations: [
        RoutingRuleComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        MaterialModule,
        SharedModule,

        ApplicationClientCommonModule
    ]
})
export class RoutingRuleModule { }

